import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../../core/services/auth.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastService } from '../../../core/services/toast.service';

@Component({
  selector: 'app-verify-email-address',
  template: ` <app-loader [centered]="true"></app-loader> `,
  standalone: false,
})
export class VerifyEmailAddressComponent implements OnInit {
  constructor(
    private authService: AuthService,
    private toastService: ToastService,
    private route: ActivatedRoute,
    private router: Router,
  ) {}

  async ngOnInit(): Promise<void> {
    try {
      await this.authService.verifyEmailAddress(
        this.route.snapshot.params['userId'],
        this.route.snapshot.params['token'],
      );
      this.toastService.success(
        'Votre adresse e-mail a été vérifiée avec succès.',
      );
      this.router.navigate(['/reservations']);
    } catch (exception) {
      // @ts-ignore
      this.toastService.error(exception.message);
      this.router.navigate(['/']);
    }
  }
}
